/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { x } from "../assets/x";
import { Icon, type IconBaseProps } from "../icon";

export const IconX = (props: IconBaseProps) => <Icon {...props} svg={x} />;

IconX.displayName = "IconX";
